module.exports = __webpack_public_path__ + "static/scen-6-ec84cce5e9b9b75892d6db84947d34e9.svg";